module.exports = __webpack_public_path__ + "static/gm-5-fb9ee60f14d3686114e3b045e4c817a4.jpg";